<label
  class="switch"
  [class.checked]="checked"
  [class.disabled]="disabled"
  [class.switch-large]="size === 'large'"
  [class.switch-medium]="size === 'medium'"
  [class.switch-small]="size === 'small'"
  [class.switch-labeled]="!!labelOn || !!labelOff">
  <span class="sr-only">Seleziona {{ariaLabel}}</span>
  <input
    type="checkbox"
    name="{{ariaLabel}}"
    [attr.aria-label]="ariaLabel"
    [checked]="checked"
    [disabled]="disabled"
    (change)="checked = !checked"
    role="switch"
    (keydown)="onKeyDown($event)"
    [attr.aria-checked]="checked"
    class="switch-input"
  />

  <small aria-hidden="true"></small>

  <span class="switch-text" *ngIf="!!labelOn || !!labelOff">
    <span class="on" [innerHTML]="labelOn"></span>
    <span class="off" [innerHTML]="labelOff"></span>
  </span>
</label>
